export class TabularGridManagerColumnResize {
    manager;
    column;
    columnWidthStart;
    columnSizeStart;
    columnAfter;
    columnAfterWidthStart;
    columnAfterSizeStart;
    dragDirection;
    resizingFn;
    resizeEndFn;
    constructor(manager, columnId, isRTL) {
        this.manager = manager;
        this.dragDirection = isRTL ? -1 : 1;
        if (this.manager.grid.columnResizeMode === "splitter") {
            this.resizingFn = this.resizingSplitter;
            this.resizeEndFn = this.resizeEndSplitter;
        }
        else {
            this.resizingFn = this.resizingSingle;
            this.resizeEndFn = null;
        }
        this.column = this.manager.columns.getColumn(columnId);
        this.columnWidthStart = this.column.getBoundingClientRect().width;
        this.columnSizeStart = this.parseCSSValue(this.column.size);
        this.columnAfter = this.manager.getNextColumn(this.column);
        this.columnAfterWidthStart =
            this.columnAfter?.getBoundingClientRect().width;
        this.columnAfterSizeStart = this.parseCSSValue(this.columnAfter.size);
    }
    resizing(deltaWidth) {
        this.resizingFn(deltaWidth);
    }
    resizeEnd() {
        if (this.resizeEndFn) {
            this.resizeEndFn();
        }
    }
    resizingSingle = (deltaWidth) => {
        const columnWidth = this.columnWidthStart - deltaWidth * this.dragDirection;
        if (columnWidth >= 0) {
            this.column.size = `minmax(min-content, ${columnWidth}px)`;
        }
    };
    resizingSplitter = (deltaWidth) => {
        const columnWidth = this.columnWidthStart - deltaWidth * this.dragDirection;
        if (columnWidth >= 0) {
            if (this.columnSizeStart) {
                this.column.size = this.convertUnit(this.columnSizeStart, this.columnWidthStart, columnWidth);
            }
            else {
                this.column.size = `minmax(min-content, ${columnWidth}px)`;
            }
        }
        if (this.columnAfter) {
            const columnAfterWidth = this.columnAfterWidthStart + deltaWidth * this.dragDirection;
            if (columnAfterWidth >= 0) {
                if (this.columnAfterSizeStart) {
                    this.columnAfter.size = this.convertUnit(this.columnAfterSizeStart, this.columnAfterWidthStart, columnAfterWidth);
                }
                else {
                    this.columnAfter.size = `minmax(min-content, ${columnAfterWidth}px)`;
                }
            }
        }
    };
    resizeEndSplitter() {
        const columnWidthEnd = this.column.getBoundingClientRect().width;
        this.column.size = this.convertUnit(this.columnSizeStart, this.columnWidthStart, columnWidthEnd);
        if (this.columnAfter) {
            const columnAfterWidthEnd = this.columnAfterWidthStart - (columnWidthEnd - this.columnWidthStart);
            this.columnAfter.size = this.convertUnit(this.columnSizeStart, this.columnWidthStart, columnAfterWidthEnd);
        }
    }
    parseCSSValue(cssValue) {
        const match = cssValue.match(/([+-]?[\d.]+)([\w%]+)/);
        if (match) {
            const number = parseFloat(match[1]);
            const unit = match[2];
            return { number, unit };
        }
        return null;
    }
    convertUnit(startSize, startWidth, newWidth) {
        return `${(newWidth * startSize.number) / startWidth}${startSize.unit}`;
    }
}
